import { render } from "./ResourceLayoutPage.vue?vue&type=template&id=02b4b8f6"
import script from "./ResourceLayoutPage.vue?vue&type=script&lang=js"
export * from "./ResourceLayoutPage.vue?vue&type=script&lang=js"

import "./ResourceLayoutPage.vue?vue&type=style&index=0&id=02b4b8f6&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__